import { directiveHooks } from '@vueuse/shared'
import onFocusOutside from '@/composables/on-focus-outside'

/** @type {import('vue').ObjectDirective<HTMLElement, import('@/composables/on-focus-outside').OnFocusOutsideHandler>} */
export default {
    [directiveHooks.mounted](el, binding) {
        (/** @type {?} */(el)).__onFocusOutside_stop = onFocusOutside(el, binding.value)
    },
    [directiveHooks.unmounted](el) {
        (/** @type {?} */(el)).__onFocusOutside_stop()
    },
}